import * as React from 'react';
import { useParams } from 'react-router-dom';
import TokenContainer from '../containers/token';

export default function SigninPage() {
    const {token} = useParams();
    return <TokenContainer token={token || ''} />;
}